import hrdag from '../../static/images/hrdag.png';
import campaign from '../../static/images/campaignzero.png';
import rockthevote from '../../static/images/rockthevote.png';
import cpe from "../../static/images/cpe.png";
import policylink from "../../static/images/policylink.png";
import ceo from "../../static/images/ceo.png";
import useofforce from "../../static/images/useofforce.png";
import policescorecard from "../../static/images/policescorecard.png";
import mappingpolice from "../../static/images/mappingpolice.png";
import votingwhileblack from "../../static/images/votingwhileblack.png";
import campaignforamericasfuture from "../../static/images/campaignforamericasfuture.png";
import d4bl from "../../static/images/d4bl.png";
import colorofchange from "../../static/images/colorofchange.png";
import eji from "../../static/images/eji.png";
import mediajustice from "../../static/images/mediajustice.png";
import justdata from "../../static/images/justdata.png";
import cpdp from "../../static/images/cpdp.png";
import hackthehood from "../../static/images/hackthehood.png";
import dreamcorps from "../../static/images/dreamcorps.png";
import alliedmedia from "../../static/images/alliedmedia.png";
import dobigthings from "../../static/images/dobigthings.png";
import blackgirlscode from "../../static/images/blackgirlscode.png";
import acludata from "../../static/images/acludata.png";
import aclu from "../../static/images/aclu.png";
import ptp from "../../static/images/ptp.png";
import govlab from "../../static/images/govlab.png";
import archive from "../../static/images/archive.png";
import upturn from "../../static/images/upturn.png";
import pew from "../../static/images/pew.png";
import civicandtech from "../../static/images/civicandtech.png";
import aei from "../../static/images/aei.png";
import moveon from "../../static/images/moveon.png";
import cbpp from "../../static/images/cbpp.png";
import alternatives from "../../static/images/alternatives.png";
import civilrights from "../../static/images/civilrights.png";
import impactjustice from "../../static/images/impactjustice.png";
import aji from "../../static/images/aji.png";
import colorcoded from "../../static/images/colorcoded.png";
import morethancode from "../../static/images/morethancode.png";
// donate links for all campaign zero related stuff
export const info = 
{
    "centerforpolicingequity": {
        title: "Center for Policing Equity",
        image: cpe,
        link: "https://policingequity.org/",
        contact: "https://policingequity.org/contact",
        donate: "https://policingequity.org/donate",
        desc: "Center for Policing Equity’s work aids police departments to realize their own equity goals as well as advance the scientific understanding of issues of equity within organizations and policing."
    },
    "campaignzero": {
        title: "Campaign Zero",
        image: campaign,
        link: "https://www.joincampaignzero.org/",
        contact: "",
        donate: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&amp;hosted_button_id=ZHQKRGV7JHCWC&amp;source=url",
        desc: "Campaign Zero is a data-informed platform that presents comprehensive solutions to end police violence in America. "
    },
    "hrdag": {
        title: "Human Rights Data Analysis Group",
        image: hrdag,
        link: "https://hrdag.org/usa/",
        contact: "",
        donate: "",
        desc: "The Human Rights Data Analysis Group is a non-profit, non-partisan organization that applies rigorous science to the analysis of human rights violations around the world."
    },
    "policylink": {
        title: "Policy Link",
        image: policylink,
        link: "https://www.policylink.org/",
        contact: "https://www.policylink.org/about-us/contact",
        donate: "https://donate.policylink.org/give/291963/#!/donation/checkout",
        desc: "PolicyLink is a national research and action institute advancing racial and economic equity through advocacy, applied research and communications, and constituency and network engagement."
    },
    "policeuseofforce": {
        title: "Police Use of Force Project",
        image: useofforce,
        link: "http://useofforceproject.org/",
        contact: "http://useofforceproject.org/planning-team",
        donate: "",
        desc: "Police Use of Force Project reviewed the use of force policies of America's 100 largest city police departments to determine whether they include meaningful protections against police violence."
    },
    "policescorecard": {
        title: "Police Scorecard",
        image: policescorecard,
        link: "https://policescorecard.org/",
        contact: "https://www.joincampaignzero.org/about/",
        donate: "https://www.paypal.me/campaignzero",
        desc: "Police Scorecard utilizes data on policing-related issues to to help communities, researchers, police leaders and policy-makers to reduce police use of force and improve accountability and public safety."
    },
    "mappingpolice": {
        title: "Mapping Police Violence",
        image: mappingpolice,
        link: "https://mappingpoliceviolence.org/",
        contact: "https://mappingpoliceviolence.org/planning-team",
        donate: "",
        desc: "Mapping Police Violence is a research collaborative collecting comprehensive data on police killings nationwide to quantify the impact of police violence in communities."
    },
    "votingwhileblack": {
        title: "Voting While Black",
        image: votingwhileblack,
        link: "https://votingwhileblack.com/",
        contact: "https://votingwhileblack.com/volunteer/",
        donate: "https://secure.actblue.com/donate/color-of-change-pac-1?refcode=vwb_nav",
        desc: "Voting While Black is invested in providing a positive space for Black folks to learn about and engage in the issues affecting our community."
    },
    "campaignforamericasfuture": {
        title: "Campaign for America's Future",
        image: campaignforamericasfuture,
        link: "https://campaignforamericasfuture.org/",
        contact: "https://campaignforamericasfuture.org/contact/",
        donate: "https://secure.actblue.com/donate/pledge4prosperity",
        desc: "The Campaign for America’s Future is a strategy center with the goal to forge the enduring progressive majority needed to realize the America of shared prosperity and equal opportunity."
    },
    "d4bl": {
        title: "Data for Black Lives",
        image: d4bl,
        link: "http://d4bl.org/",
        contact: "http://d4bl.org/about.html",
        donate: "https://secure.actblue.com/donate/data-for-black-lives-1?refcode=d4blsite",
        desc: "Data for Black Lives is a movement of activists, organizers, and mathematicians committed to the mission of using data science to create concrete and measurable change in the lives of Black people."
    },
    "colorofchange": {
        title: "Color of Change",
        image: colorofchange,
        link: "https://colorofchange.org/",
        contact: "https://colorofchange.org/contact-us/",
        donate: "https://secure.actblue.com/contribute/page/support-us",
        desc: "Color of Change designs campaigns powerful enough to end practices that unfairly hold Black people back, and champion solutions that move us all forward. "
    },
    "eji": {
        title: "Equal Justice Initiative",
        image: eji,
        link: "https://eji.org/",
        contact: "https://eji.org/contact/",
        donate: "https://support.eji.org/give/153413/#!/donation/checkout",
        desc: "The Equal Justice Initiative is committed to ending mass incarceration and excessive punishment in the US, challenging racial and economic injustice, and protecting basic human rights for the most vulnerable people in American society."
    },
    "mediajustice": {
        title: "MediaJustice",
        image: mediajustice,
        link: "https://mediajustice.org/issue/high-tech-policing/",
        contact: "https://mediajustice.org/contact-us/",
        donate: "https://www.classy.org/give/228848/#!/donation/checkout",
        desc: "Media Justice strives to create a media and technology environment that fuels real justice in this crucial moment in our struggle for freedom—freedom from oppression, freedom to communicate."
    },
    "idajustdatalab": {
        title: "Ida B. Wells Just Data Lab",
        image: justdata,
        link: "https://www.thejustdatalab.com/",
        contact: "https://www.thejustdatalab.com/contact-information",
        donate: "",
        desc: "The IDA B. WELLS Just Data Lab brings together students, educators, activists, and artists  to develop a critical and creative approach to data conception, production, and circulation."
    },
    "cpdp": {
        title: "Citizens Police Data Project",
        image: cpdp,
        link: "https://cpdp.co/",
        contact: "https://cpdp.co/",
        donate: "",
        desc: "Citizens Police Data Project collects and publishes information about police misconduct in Chicago."
    },
    "hackthehood": {
        title: "Hack the Hood",
        image: hackthehood,
        link: "https://www.hackthehood.org/",
        contact: "https://www.hackthehood.org/contact-us.html",
        donate: "https://www.hackthehood.org/donate.html",
        desc: "Hack the Hood empowers under-resourced youth of color with knowledge, skills, and relationships needed to succeed in tech careers and become creators of change in their communities."
    },
    "dreamcorps": {
        title: "Dream Corps Tech",
        image: dreamcorps,
        link: "https://www.thedreamcorps.org/our-programs/tech/",
        contact: "https://www.thedreamcorps.org/our-programs/tech/about/contact-us/",
        donate: "https://act.thedreamcorps.org/donate/donate/",
        desc: "Dream Corps TECH is a national program cultivating future leaders and entrepreneurs from underrepresented backgrounds, creating a pipeline of diverse talent that will shift the culture of the tech sector."
    },
    "alliedmedia": {
        title: "Allied Media Projects",
        image: alliedmedia,
        link: "https://alliedmedia.org/",
        contact: "https://alliedmedia.org/contact-5",
        donate: "https://alliedmedia.org/sustain",
        desc: "Allied Media Project produces the Allied Media Conference and supports art, media, and technology projects working for social change."
    },
    "dobigthings": {
        title: "Do Big Things",
        image: dobigthings,
        link: "https://dobigthings.today/",
        contact: "https://dobigthings.today/contact-us/",
        donate: "",
        desc: "Do Big Things is a diverse women-owned and women-led, creative digital agency that partners with progressive campaigns, causes and companies fighting for powerful, lasting change.",
    },
    "blackgirlscode": {
        title: "Black Girls Code",
        image: blackgirlscode,
        link: "https://www.blackgirlscode.com/",
        contact: "https://www.blackgirlscode.com/contact-us.html",
        donate: "https://donorbox.org/support-black-girls-code?default_interval=o",
        desc: "Black Girls Code aims to empower girls of color ages 7 to 17 to become innovators in STEM fields, leaders in their communities, and builders of their own futures through computer science and technology."
    },
    "acludata": {
        title: "(ACLU Massachusetts) Data for Justice Project",
        image: acludata,
        link: "https://data.aclum.org/",
        contact: "https://data.aclum.org/contact-us/",
        donate: "",
        desc: "Data for Justice is a project that aims to arm activists, advocates, journalists, policy makers, and elected officials with relevant, timely information about how government functions."
    },
    "aclu": {
        title: "ACLU",
        image: aclu,
        link: "https://www.aclu.org/",
        contact: "https://www.aclu.org/contact-us/",
        donate: "https://action.aclu.org/give/now?ms_aff=NAT&initms_aff=NAT&ms=web_horiz_nav_hp&initms=web_horiz_nav_hp&ms_chan=web&initms_chan=web",
        desc: "The ACLU dares to create a more perfect union — beyond one person, party, or side. Its mission is to realize this promise of the United States Constitution for all and expand the reach of its guarantees."
    },
    "govlab": {
        title: "(The Governance Lab @ NYU) Data-Driven Criminal Justice Project",
        image: govlab,
        link: "http://www.thegovlab.org/project-data-driven-criminal-justice.html",
        contact: "http://www.thegovlab.org/contact.html",
        donate: "",
        desc: "The GOVLAB works to strengthen the ability of institutions and people to work more openly, collaboratively, effectively and legitimately to make better decisions and solve public problems."
    },
    "ptp": {
        title: "Progressive Technology Project",
        image: ptp,
        link: "https://www.progressivetech.org/",
        contact: "https://www.progressivetech.org/contact/",
        donate: "https://www.progressivetech.org/donate/",
        desc: "PTP is a social justice movement partner with a mission to strengthen grassroots organizing groups to achieve their goals more effectively and efficiently through the strategic use of technology."
    },
    "archiving": {
        title: "A People's Archive of Police Violence in Cleveland",
        image: archive,
        link: "https://www.archivingpoliceviolence.org/",
        contact: "https://www.archivingpoliceviolence.org/contact",
        donate: "https://www.archivingpoliceviolence.org/support",
        desc: "A People’s Archive of Police Violence in Cleveland collects, preserves, and shares the stories, memories, and accounts of police violence as experienced or observed by Cleveland citizens. "
    },
    "upturn": {
        title: "Upturn",
        image: upturn,
        link: "https://www.upturn.org/",
        contact: "https://www.upturn.org/contact/",
        donate: "",
        desc: "Upturn advances equity and justice in the design, governance, and use of technology by bringing computer science, quantitative, and legal and policy expertise to bear on the most pressing civil rights challenges."
    },
    "centertechandcivic": {
        title: "Center for Tech and Civic Life",
        image: civicandtech,
        link: "https://www.techandciviclife.org/#",
        contact: "mailto:hello@techandciviclife.org",
        donate: "https://www.techandciviclife.org/donate/",
        desc: "The Center for Tech and Civic Life connects Americans with the information they need to become and remain civically engaged, and ensure that our elections are more professional, inclusive, and secure."
    },
    "rockthevote": {
        title: "Rock The Vote",
        image: rockthevote,
        link: "https://www.rockthevote.org/",
        contact: "https://www.rockthevote.org/about-rock-the-vote/contact/",
        donate: "https://www.rockthevote.org/about-rock-the-vote/donate/",
        desc: "Rock the Vote pioneers innovative ways to make democratic participation more accessible, while also uplifting and empowering young people’s right to vote."
    },
    "pew": {
        title: "Pew Research Center",
        image: pew,
        link: "https://www.pewresearch.org/",
        contact: "https://www.pewresearch.org/contact/",
        donate: "https://pewresearch.networkforgood.com/?utm_source=PewResearch&utm_medium=InternalPromo&utm_campaign=TopDonateButton",
        desc: "Pew Research Center is a nonpartisan fact tank that informs the public about the issues, attitudes and trends shaping the world. "
    },
    "aei": {
        title: "American Enterprise Institute",
        image: aei,
        link: "https://www.aei.org/",
        contact: "https://www.aei.org/about/contact/",
        donate: "https://www.aei.org/donate/",
        desc: "The American Enterprise Institute is a public policy think tank dedicated to defending human dignity, expanding human potential, and building a freer and safer world. "
    },
    "moveon": {
        title: "MoveOn",
        image: moveon,
        link: "https://front.moveon.org/",
        contact: "https://front.moveon.org/contact-us/",
        donate: "https://act.moveon.org/donate/civ-donation?utm_source=front&utm_content=nav&source=front_nav",
        desc: "Whether it’s supporting a candidate, passing legislation, or changing our culture, MoveOn is where millions mobilize for a better society—one where everyone can thrive."
    },
    "ceo": {
        title: "Center for Equal Opportunity",
        image: ceo,
        link: "https://www.ceousa.org/",
        contact: "http://ceousa.org/contact-us-menu",
        donate: "https://www.ceousa.org/index.php",
        desc: "The Center for Equal Opportunity is the nation’s only conservative think tank devoted to issues of race and ethnicity."
    },
    "cbpp": {
        title: "Center on Budget and Policy Priorities",
        image: cbpp,
        link: "https://www.cbpp.org/",
        contact: "https://www.cbpp.org/about/contact",
        donate: "https://www.cbpp.org/donate",
        desc: "The Center on Budget and Police Priorities is a nonpartisan research and policy institute that pursues federal and state policies designed to reduce poverty and inequality and restore fiscal responsibility in equitable and effective ways. "
    },
    "theleadershipcivilrights": {
        title: "The Leadership Conference on Civil & Human Rights",
        image: civilrights,
        link: "https://civilrights.org/",
        contact: "https://civilrights.org/contact/",
        donate: "https://secure.actblue.com/donate/lcchr",
        desc: "The Leadership Conference on Civil and Human Rights is a coalition charged by its diverse membership of more than 200 national organizations to promote and protect the civil and human rights of all persons in the United States."
    },
    // "alternative": {
    //     title: "Alternatives to Calling the Police During Mental Health Crises",
    //     image: alternatives,
    //     link: "https://www.facebook.com/ACPDMHC/about/?ref=page_internal",
    //     contact: "https://www.facebook.com/ACPDMHC/about/?ref=page_internal",
    //     donate: "",
    //     desc: "Through the project, ACP continues to imagine what a world without police can look like, and a world where widespread over-policing and mass incarceration are replaced with equitable investment, community care, and restorative justice."
    // },
    "impactjustice": {
        title: "Impact Justice",
        image: impactjustice,
        link: "https://impactjustice.org/",
        contact: "https://impactjustice.org/contact-us/",
        donate: "https://impactjustice.org/donate/",
        desc: "Impact Justice is a national innovation and research center advancing new ideas and solutions for justice reform."
    },
    "aji": {
        title: "Algorithmic Justice League",
        image: aji,
        link: "https://www.ajl.org/",
        contact: "https://www.ajl.org/contact",
        donate: "https://filmmakerscollab.networkforgood.com/projects/26497-filmmakers-collaborative-current-projects-algorithmic-justice-league",
        desc: "The Algorithmic Justice League is an organization that combines art and research to illuminate the social implications and harms of artificial intelligence."
    },
    "colorcoded": {
        title: "Color Coded",
        image: colorcoded,
        link: "https://colorcoded.la/",
        contact: "",
        donate: "https://colorcoded.la/support-us",
        desc: "Color Coded is a POC-only transformative space that centers historically-excluded people in the co-teaching, co-creation, and co-ownership of new technologies."
    },
    "morethancode": {
        title: "More Than code",
        image: morethancode,
        link: "https://morethancode.cc/",
        contact: "",
        donate: "",
        desc: "#MoreThanCode aims to make the voices of diverse technology practitioners heard. These practitioners include software developers, designers, and project managers, as well as researchers, policy advocates, and many others."
    },
}
console.log(info)

export const taglist = {
    "centerforpolicingequity": ["police reform", "data"],
    "campaignzero": ["police reform", "data"],
     "hrdag": ["police reform", "prison reform", "data", "covid-19"],
     "policylink": ["racial injustice", "equal opportunity", "covid-19"],
     "policeuseofforce": ["police reform"],
     "policescorecard": ["police reform"],
     "mappingpolice": ["police reform"],
     "votingwhileblack": ["voting"],
     "campaignforamericasfuture": ["equal opportunity"],
     "d4bl": ["police reform", "data", "racial injustice", "equal opportunity", "covid-19"],
     "colorofchange": ["police reform", "racial injustice", "equal opportunity", "voting"],
     "eji": ["prison reform", "racial injustice", "equal opportunity"],
     "mediajustice": ["police reform", "prison reform", "racial injustice", "covid-19"],
     "idajustdatalab": ["racial injustice", "data", "covid-19"],
     "cpdp": ["police reform", "data"],
     "hackthehood": ["equal opportunity", "data"],
     "dreamcorps": ["equal opportunity", "data"],
     "alliedmedia": ["racial injustice"],
     "dobigthings": ["equal opportunity"],
     "blackgirlscode": ["equal opportunity", "data"],
     "acludata": ["racial injustice", "data"],
     "aclu": ["prison reform", "racial injustice", "police reform"],
     "govlab": ["prison reform", "data"],
     "ptp": ["equal opportunity", "data"],
     "archiving": ["police reform"],
     "upturn": ["police reform", "racial injustice", "data", "equal opportunity"],
     "centertechandcivic": ["voting", "data"],
     "rockthevote": ["voting"],
     "pew": ["police reform", "data", "racial injustice", "equal opportunity", "covid-19", "prison reform", "voting"],
     "aei": ["equal opportunity", "prison reform", "racial injustice"],
     "moveon": ["racial injustice", "equal opportunity", "police reform"],
     "ceo": ["equal opportunity"],
     "cbpp": ["equal opportunity", "data"],
     "theleadershipcivilrights": ["police reform", "prison reform", "racial injustice", "equal opportunity", "voting"],
    //  "alternative": ["police reform"], 
     "impactjustice": ["prison reform, police reform, racial injustice"],
     "aji": ["racial injustice", "data"],
     "colorcoded": ["racial injustice", "equal opportunity", "data"],
     "morethancode": ["equal opportunity", "data"]

}
